import { h, Component } from "preact";

import selectTriangle from "./images/select_triangle.svg";

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      value: props.values.find(v => v.value === props.defaultValue) || ""
    };

    this.toggle = this.toggle.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
  }

  onChange(value) {
    this.setState({
      value
    });

    this.props.onChange(value);
  }

  toggle(e) {
    e.stopPropagation();
    this.setState({
      open: !this.state.open
    });
  }

  onSearchChange(e) {
    this.setState({
      search: e.target.value
    });
  }

  render({ values = [], typeaHead = false }, { value, open, search }) {
    let filteredValues = [...values];

    if (typeaHead) {
      filteredValues = filteredValues.filter(v => v.label === search);
    }

    return (
      <div class="user-widget__dropdown">
        <button
          class="user-widget__dropdown__label"
          onClick={this.toggle}
          onKeyUp={e => e.keyCode === 13 && this.toggle}
        >
          <span>{value.label}</span>
          <img
            class={`${open && "user-widget__dropdown__icon--open"}`}
            src={selectTriangle}
            alt="chevron"
          />
        </button>
        <div
          class={`user-widget__dropdown__menu ${open &&
            "user-widget__dropdown__menu--open"}`}
        >
          {typeaHead && (
            <input type="text" onChange={this.onSearchChange} value={search} />
          )}
          {filteredValues.map(value => (
            <button class="option" onClick={() => this.onChange(value)}>{value.label}</button>
          ))}
        </div>
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/Dropdown.js